import { User } from "@genericComponents/User.js";
export const MaintainSiteMap = {
  Process: null,
  ProductCode: null,
  LanguageCode: null,
  SiteMapId: null,
  Url: null,
  Exclude: null,
  Title: null,
  GUID: null,
  Image: null,
  CanonicalSiteMapId: null,
  CanonicalUrl: null,
};
export const MaintainMessage = {
  MessageGuid: null,
  Url: null,
  Title: null,
  Message: null,
  ParticipantsGUID: null,
  MessageId: null,
  ModifiedGUID: User.UserGUID(),
  PageIndex: 0,
};
export const MaintainTranslations = {
  Filter: {
    _id: null,
    TranslationTypeId: null,
    LanguageCode: null,
    TranslationDescription: null,
  },
  Process: null,
  _id: null,
  TranslationTypeId: null,
  LanguageCode: null,
  TranslationDescription: null,
};
export const MaintainUsers = {
  Process: null,
  UserGUID: null,
  PromoCode: null,
  ReferralsPromoCode: null,
  Picture: null,
  Email: null,
  Password: null,
  ConfirmPassword: null,
  FullName: null,
  NickName: null,
  UserStatusId: null,
  Address: null,
  Gender: null,
  Roles: null,
  ContactNumber: null,
  DateJoined: null,
  BirthDate: null,
  CountryId: null,
  FacebookId: null,
  TwitterId: null,
  LinkedInId: null,
  GoogleId: null,
  PaypalEmailAddress: null,
  ActivationCode: null,
  ModifiedGUID: User.UserGUID(),
  ModifiedDate: null,
  TimeZone: new Date().getTimezoneOffset() / 60,
  PageIndex: 0,
  Remarks: null,
  Points: null,
  ShareUrl: null,
};
export const MaintainDynamicOptions = {
  Process: null,
  DynamicOptionsId: null,
  DynamicOptionsName: null,
  DynamicOptionTypeId: null,
  Description: null,
  SortId: null,
  LanguageCode: null,
  ModifiedGUID: User.UserGUID(),
  ModifiedDate: null,
  TimeZone: new Date().getTimezoneOffset() / 60,
  PageIndex: 0,
  FixWidthForImages: null,
  Picture: null,
};
export const MaintainTranslationType = {
  Process: null,
  TranslationTypeId: null,
  ProductCode: null,
  Category: null,
  LanguageCode: null,
  TranslationTypeName: null,
  ModifiedGUID: User.UserGUID(),
  ModifiedDate: null,
  TimeZone: new Date().getTimezoneOffset() / 60,
  PageIndex: 0,
  TranslationTypeIds: null,
};
export const MaintainDialog = {
  title: null,
  showpb: true,
  shownb: false,
  pb: null,
  nb: null,
  msg: null,
  children: null,
};
export const MaintainFilter = {
  title: "225",
  msg: null,
  currentState: null,
  factoryState: null,
};
